import type { SATheme } from '../../types/stylingAssistant.types';

interface SALoadingIndicatorProps {
  theme: SATheme;
}

export default function SALoadingIndicator({ theme }: SALoadingIndicatorProps) {
  return (
    <div className="flex items-center gap-3 py-4">
      <div className="flex gap-2">
        <div
          className="w-2 h-2 rounded-full animate-bounce bg-[#EE4423]"
          style={{ animationDelay: '0ms' }}
        />
        <div
          className="w-2 h-2 rounded-full animate-bounce bg-[#EE4423]"
          style={{ animationDelay: '150ms' }}
        />
        <div
          className="w-2 h-2 rounded-full animate-bounce bg-[#EE4423]"
          style={{ animationDelay: '300ms' }}
        />
      </div>
      <span className="text-xs text-gray-500">Finding the best styles for you...</span>
    </div>
  );
}
